import { createSelector } from 'reselect';
import { whatIfOrDefaultSelector, whatIfInnerSelector } from '../../WhatIfsSelector';

export const retirementExpensesOptionsSelector = (state, props) => {
  const whatIf = whatIfOrDefaultSelector(state, props);
  const whatIfOptions = whatIf.Options || {};
  return (whatIfOptions.RetirementExpensesOptions || []).map(({ description, value }) => ({
    label: description,
    value,
  }));
};

export const retirementExpensesSelector = (state, props) =>
  whatIfInnerSelector(state, props).RetirementExpenses;

export const retirementExpensesAmountSelector = (state, props) =>
  whatIfInnerSelector(state, props).RetirementExpenseAmount;

export const hasRetirementExpensesAmountSelector = createSelector(
  retirementExpensesSelector,
  retirementExpenses => retirementExpenses === 21,
);
